import {
  // ExpandIcon,
  Flex,
  IconButton,
  Text,
} from '@pancakeswap/uikit'
import { CurrencyLogo, DoubleCurrencyLogo } from 'components/Logo'
// import { useTranslation } from 'contexts/Localization'
import React from 'react'
import { ChartViewMode } from 'state/user/actions'
import { useExchangeChartViewManager } from 'state/user/hooks'
import styled from 'styled-components'
// import BasicChart from './BasicChart'
import PriceTradingBasicChart from './PriceTradingBasicChart'
import { StyledPriceChart } from './styles'
import { ReactComponent as SwapAltIcon } from '../../../../assets/images/swap-alt.svg'
import useTheme from 'hooks/useTheme'
import WalletTransactions from 'components/Menu/UserMenu/WalletTransactions'
// import TradingViewChart from './TradingViewChart'

// const ChartButton = styled(Button)`
//   background-color: ${({ $active, theme }) => $active && `${theme.colors.primary}0f`};
//   padding: 4px 8px;
//   border-radius: 6px;
// `

const SwapIcon = styled.div`
  position: relative;
  z-index: 2;
  margin: -12px 0 -20px;
  cursor: pointer;
  transition: 0.3s;
  transform-origin: 7px 7px;
  :hover {
    transform: rotate(180deg);
  }
`

const PriceChart = ({
  inputCurrency,
  outputCurrency,
  onSwitchTokens,
  isDark,
  isChartExpanded,
  // setIsChartExpanded,
  isMobile,
  token0Address,
  token1Address,
}) => {
  // const { isDesktop } = useMatchBreakpoints()
  // const toggleExpanded = () => setIsChartExpanded((currentIsExpanded) => !currentIsExpanded)
  const { theme } = useTheme()
  const [chartView, setChartView] = useExchangeChartViewManager()

  return (
    <StyledPriceChart height="100%" overflow="hidden" $isDark={isDark} $isExpanded={isChartExpanded}>
      <Flex>
        <Text mb="8px" ml="20px" fontSize="24px">
          Exchange Rates
        </Text>
      </Flex>
      <Flex justifyContent="space-between" px="24px">
        <Flex alignItems="center">
          {outputCurrency ? (
            <DoubleCurrencyLogo currency0={inputCurrency} currency1={outputCurrency} size={24} margin />
          ) : (
            inputCurrency && <CurrencyLogo currency={inputCurrency} size="24px" style={{ marginRight: '8px' }} />
          )}
          {inputCurrency && (
            <Text color="text">
              {outputCurrency ? `${inputCurrency.symbol}/${outputCurrency.symbol}` : inputCurrency.symbol}
            </Text>
          )}
          <IconButton variant="text" onClick={onSwitchTokens} style={{ paddingBottom: 8, paddingLeft: 3 }}>
            <SwapIcon>
              <SwapAltIcon width="14px" color={theme.colors.textSubtle} />
            </SwapIcon>
            {/* <SyncAltIcon ml="6px" color="primary" /> */}
          </IconButton>
        </Flex>
      </Flex>
      {chartView === ChartViewMode.BASIC && (
        // <BasicChart
        //   token0Address={token0Address}
        //   token1Address={token1Address}
        //   isChartExpanded={isChartExpanded}
        //   inputCurrency={inputCurrency}
        //   outputCurrency={outputCurrency}
        //   isMobile={isMobile}
        //   currentSwapPrice={currentSwapPrice}
        // />
        <PriceTradingBasicChart
          token0Address={token0Address}
          token1Address={token1Address}
          isChartExpanded={isChartExpanded}
          inputCurrency={inputCurrency}
          outputCurrency={outputCurrency}
          isMobile={isMobile}
          setChartView={setChartView}
          chartMode="BASIC"
        />
      )}
      {chartView === ChartViewMode.TRADING_VIEW && (
        <PriceTradingBasicChart
          token0Address={token0Address}
          token1Address={token1Address}
          isChartExpanded={isChartExpanded}
          inputCurrency={inputCurrency}
          outputCurrency={outputCurrency}
          isMobile={isMobile}
          setChartView={setChartView}
          chartMode="CANDLE"
        />
      )}
      {/* {chartView === ChartViewMode.TRADING_VIEW && (
        <TradingViewChart
          // unmount the whole component when symbols is changed
          key={`${inputCurrency?.symbol}-${outputCurrency?.symbol}`}
          isChartExpanded={isChartExpanded}
          inputCurrency={inputCurrency}
          outputCurrency={outputCurrency}
          token0Address={token0Address}
          isMobile={isMobile}
          isDark={isDark}
          currentSwapPrice={currentSwapPrice}
        />
      )} */}
      <div style={{ padding: 20 }}>
        <WalletTransactions />
      </div>
    </StyledPriceChart>
  )
}

export default PriceChart
